module.exports = __webpack_public_path__ + "prod/1.42.2/img/pre_img3.4559d5ad.png";